import { createSlice } from "@reduxjs/toolkit";

const initialLanguage = localStorage.getItem("language") || "en";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    currentLanguage: initialLanguage,
  },
  reducers: {
    changeLanguage: (state, action) => {
      state.currentLanguage = action.payload;
      localStorage.setItem("language", action.payload); // Persist language preference
    },
  },
});

export const { changeLanguage } = languageSlice.actions;
export const selectCurrentLanguage = (state) => state.language.currentLanguage;
export default languageSlice.reducer;
